import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import '../assets/css/style.css';
import DanLogo from '../assets/img/dan-logo.svg';
import DoneCashback from '../assets/img/DONE-Cashback-System.svg';
import BackIcon from '../assets/img/back-btn.svg';
import OTPInput from './otpinput';
import CountdownTimer from './otptimer';

function RegOtptDan() {
  const navigate = useNavigate(); 
  const [otp, setOtp] = useState(""); // ذخیره کد OTP
  const [error, setError] = useState(""); // ذخیره خطا
  const mobile = localStorage.getItem("mobile"); // دریافت شماره موبایل ذخیره‌شده

  const handleVerifyOTP = async () => {
    if (!otp) {
      setError("لطفاً کد تایید را وارد کنید.");
      return;
    }

    try {
      const response = await fetch("https://app.doneapp.ir/backend/register.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          mobile,
          otp
        }),
      });

      const data = await response.json();
      if (data.status === "success") {
        navigate("/register-form"); // انتقال به فرم ثبت نام
      } else {
        setError(data.message); // نمایش پیام خطا
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      setError("خطا در تایید کد. لطفاً دوباره تلاش کنید.");
    }
  };

  return (
    <> 
      <div className="start-bdy">
        <button className="back-btn-1" onClick={() => navigate("/register")}>
          <img src={BackIcon} alt='back' />
        </button>
        <div className="logomotion tw-200">
          <div className="start-logo">
            <img src={DanLogo} alt="Dan Logo" />
            <img className="mt-15" src={DoneCashback} alt="Done Cashback System" />
          </div>
        </div>

        <div className="loginbtns-2">
          <div className="btndiv-1">
            <div className='forget-title-1'>
              کد تایید پیامک شده را وارد نمایید
            </div>
            <OTPInput value={otp} onChange={setOtp} />
            <CountdownTimer initialTime={120} /> 

            {error && <p className="error-text">{error}</p>} {/* نمایش خطا */}

            <button type="submit" className="loginbtn-1" onClick={handleVerifyOTP}>
              تایید کد ورود
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default RegOtptDan;
